import * as React from 'react';
import {Col, Container, Row} from 'reactstrap';
import RechazosForm from './rechazos-form';
import fileDownload from 'js-file-download';
import MiranaServiceClient from '../../../middleware/mirana-client';
import {lazyInject, TYPES} from '../../../utils/inversify-config';
import RechazosTable from './rechazos-table';
import * as moment from 'moment';
import {error, success} from '../../../utils/notification-actions';
import {connect} from 'react-redux';
import {mirana} from '@wize/mirana-proto/mirana-proto';
import {getFileName} from '../../../utils/utils';

interface RechazoState {
    rechazos?: mirana.IUIRechazo[];
    total: number;
    fuerzaVenta?: string;
    fechaInicio: string;
    fechaFin: string;
    fuerzaVentaId?: string;
    mesaId?: string;
    rutaId?: string;
    rutaDespachoId?: string;
    motivoAnulacionId?: string;
}

class Rechazos extends React.PureComponent<ReduxProps, RechazoState> {

    @lazyInject(TYPES.MIRANA_SERVICE)
    public apiClient: MiranaServiceClient;

    constructor(props, state) {
        super(props, state);

        this.state = {
            total: 0,
            fechaInicio: '',
            fechaFin: ''
        };

        this.handleFiltrar = this.handleFiltrar.bind(this);
        this.handleGenerarExcel = this.handleGenerarExcel.bind(this);
    };

    public async handleFiltrar(values) {
        const fechaInicio = moment(values.intervalo.start).format('DD/MM/YYYY');
        const fechaFin = moment(values.intervalo.end).format('DD/MM/YYYY');
        const fuerzaVentaId = values.fuerzaVenta ? values.fuerzaVenta.value : null;
        const mesaId = values.mesa ? values.mesa.value : null;
        const rutaId = values.vendedor ? values.vendedor.value : null;
        const rutaDespachoId = values.rutaDespacho ? values.rutaDespacho.value : null;
        const motivoAnulacionId = values.motivoAnulacion ? values.motivoAnulacion.value : null;

        try {
            const response = await this.apiClient.filtrarRechazos(
                fechaInicio, fechaFin, fuerzaVentaId,
                mesaId, rutaId, rutaDespachoId, motivoAnulacionId);
            this.setState({
                total: response.total,
                rechazos: response.rechazos,
                fuerzaVenta: response.fuerzaVenta,
                fechaInicio, fechaFin,
                fuerzaVentaId, mesaId,
                rutaId, rutaDespachoId, motivoAnulacionId
            });
            this.props.dispatch(success('Notificación', `Rechazos encontrados: ${this.state.rechazos ? this.state.rechazos.length : '0'}`));
        } catch (ex) {
            this.props.dispatch(error('Error', 'Error interno al filtrar rechazos'));
        }
    }

    public async handleGenerarExcel() {
        const {fechaInicio, fechaFin, fuerzaVentaId, mesaId, rutaId, rutaDespachoId, motivoAnulacionId} = this.state;
        const response = await this.apiClient.descargarRechazos(fechaInicio, fechaFin, fuerzaVentaId,
            mesaId, rutaId, rutaDespachoId, motivoAnulacionId);
        fileDownload(response.data, getFileName(response));

    }

    public render() {
        return (
            <Container>
                <Row>
                    <Col md={12}>
                        <h3 className='page-title'>Rechazos</h3>
                    </Col>
                </Row>
                <Row>
                    <RechazosForm onSubmit={this.handleFiltrar}/>
                    <RechazosTable handleGenerarExcel={this.handleGenerarExcel}
                                   rechazos={this.state.rechazos}
                                   total={this.state.total}
                                   fechaInicio={this.state.fechaInicio}
                                   fechaFin={this.state.fechaFin}
                                   fuerzaVenta={this.state.fuerzaVenta}/>
                </Row>
            </Container>
        );
    }
}

export default connect()(Rechazos);



// WEBPACK FOOTER //
// ./src/components/pages/rechazos/rechazos.tsx